import { faInboxIn, faInboxOut } from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  FamilyChildProfile,
  JoonUIColor,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import useMailboxStore from "./hooks/useMailboxStore"
import NotificationDot2 from "../../../../components/notificationDot/NotificationDot2"
import { useFamilyMailQuery } from "../../../../networking/queries"
import { FamilyMail } from "../../../../types"
import { getMessageTime } from "../../../../util/mail"
import { getChildImage } from "../../../../util/util"

const RecentMailItem = ({
  mail,
  child,
}: {
  mail: FamilyMail | undefined
  child: FamilyChildProfile
}) => {
  const { onOpenChildMailbox } = useMailboxStore()
  const { t } = useTranslation()

  const { data: unreadMail } = useFamilyMailQuery({
    isUnread: true,
    childId: child.user.id,
  })

  const hasUnreadMail = unreadMail && unreadMail.length > 0

  const handleViewMailbox = () => {
    onOpenChildMailbox(child.user.id)
  }

  const childImage = getChildImage(child.user)
  const messageTime = mail ? getMessageTime(mail) : ""

  return (
    <button onClick={handleViewMailbox} className="w-full text-left">
      <div className="flex gap-2 items-center hover:bg-gray-100 p-2 rounded-md">
        <img
          src={childImage}
          className="w-9 h-9 rounded-full"
          alt={child.user.name}
        />
        <div className="flex flex-col w-full items-start">
          <div className="flex flex-row justify-between w-full">
            <div className="flex items-center gap-1">
              {hasUnreadMail && <NotificationDot2 />}
              <Typography variant="bodySmall">{child.user.name}</Typography>
            </div>
            <Typography variant="bodyXSmall" color={JoonUIColor.text.secondary}>
              {messageTime}
            </Typography>
          </div>
          {mail ? (
            <div className="flex flex-row gap-1 items-start">
              <FontAwesomeIcon
                icon={mail.sender.id === child.user.id ? faInboxIn : faInboxOut}
                color={JoonUIColor.icon.neutral}
                fontSize={12}
                className="mt-[3px]"
              />
              <Typography variant="bodySmall">{mail.body}</Typography>
            </div>
          ) : (
            <Typography
              variant="bodySmall"
              color={JoonUIColor.text.primaryAccent}
            >
              {t("MAIL_SAY_HI")}
            </Typography>
          )}
        </div>
      </div>
    </button>
  )
}

export default RecentMailItem
